// React
import { useEffect, useLayoutEffect, useRef, useState } from "react";

// Router
import { useLocation, useNavigate, useParams } from "react-router-dom";

// Redux
import { useDispatch, useSelector } from "react-redux";

import { disableSwitcher } from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";

// Utils
import {
  GlobalConfiguration,
  IntervalConfiguration,
  RejectReasonLength,
} from "../../../utils/configurationProvider.js";
import formatDateViewAll from "../../../utils/formatDateViewAll.js";
import TEXT from "../../../utils/globalText.js";
import formatCurrency from "../../../utils/CurrencyFormater.js";
import useCategories from "../../../utils/useCategories.js";

// Components / UI
import TopNavSmallButton from "../../../components/_utils/CommonButtons/TopNavSmallButton/index.jsx";
import { formatAccountNumber } from "../../../components/_utils/FormatAccountNumber/index.js";
import SVGComponent from "../../../components/_utils/SVGComponent/index.jsx";
import FullScreen from "../../../components/FullScreen/index.jsx";
import Loader from "../../../components/Loader/Index.jsx";
import TitleSubtitlePair from "../../../components/_utils/TitleSubtitlePair/index.jsx";
import CommonBankLogo from "../../../components/_utils/CommonBankLogo/index.jsx";
import TimelineStatusBar from "../../../components/_utils/TimelineCommonComponents/TimelineStatusBar/index.jsx";
import SwitcherTabs from "../../../components/_utils/CommonButtons/SwitcherTabs/index.jsx";
import CommonDetailCard from "../../../components/_utils/CommonDetailCard/index.jsx";
import CommonToast from "../../../components/_utils/CommonToast/index.jsx";
import ICONS from "../../../assets/Icons/index.js";
import LargePopupRedirect from "../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import CommonTimeLineCard, {
  addLifeCycleStatus,
} from "../../../components/CommonTimeLineCard/index.jsx";
import OwnerAccountDetailsPopUp from "../../../components/Accounts/OwnerAccount/OwnerAccountDetailsPopUp/index.jsx";
import { toast_position } from "../../../redux/features/Settings/Authorization/index.js";
import TimelinePopupContent from "../../../components/_utils/TimelinePopupContent/index.jsx";
import {
  clearrequestTxnError,
  fieldforcerequestTxnReject,
  getSpecificFieldForceRequest,
} from "../../../redux/features/fieldForceRequest/index.js";
// import FieldForceRequestViewAllPopup from "../../../components/FieldForceRequestTransactionComp/FieldForceRequestViewAllPopup/index.jsx";
import FieldForceAccountDetailsPopup from "../../../components/_utils/FieldForceAccountDetailsPopup/index.jsx";
import FieldForceRequestViewAllPopup from "../../../components/FieldForceTransactionComp/FieldForceRequestViewAllPopup/index.jsx";
import useRestrictedAction from "../../../hooks/useRestrictedAction.js";
import globalText from "../../../utils/globalText.js";
import MediumImagePopup from "../../../components/_utils/MediumImagePopup/index.jsx";
import SmallPopupWithBulletPoints from "../../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";

const FieldForceRequestDetail = ({
  isPopup,
  txn_id,
  detailSelected,
  field_force_request_id,
  type,
  closePopup,
  flow,
}) => {
  // useDispatch, useNavigate, useParams (and id from params)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const previousStatus = useLocation()?.state?.options?.state;

  // useRef
  const leftContentRef = useRef(null);
  const cardRefs = useRef({});

  //useState
  const [RequestHistory, setRequestHistory] = useState(false);
  const [RequestAccName, setRequestAccName] = useState("");
  const [scheduleUpdatedData, setScheduleUpdatedData] = useState([]);
  const [timelinedatabottom, setTimelinedatabottom] = useState([]);
  const [isloading, setIsLoading] = useState(true);
  const [alertPopUp, setAlertPopUp] = useState(false);
  const [doneBinding, setDoneBinding] = useState(false);
  const [BeneAccountId, setBeneAccountId] = useState("");
  const [showRejectPrompt, setShowRejectPrompt] = useState(false);
  const [requestId, setRequestId] = useState("");
  const [showRequestAccModal, setShowRequestAccModal] = useState(false);
  const [OwnerDetailpop, setOwnerDetailpop] = useState(false);
  const [ReimburseAccountDetailpop, setReimburseAccountDetailpop] =
    useState(false);
  const [selectedDetail, setSelectedDetail] = useState(
    flow === "request_additional" ? "Support details" : "Transaction details",
  );
  const [openImageUrl, setOpenImageUrl] = useState(false);
  const [selectedImage, setSelectedImage] = useState({});

  const [showDetails, setShowDetails] = useState(true);
  const [rightHeight, setRightHeight] = useState("auto");
  const [showLoader, setShowLoader] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [inputDisabled, setInputDisabled] = useState(false);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [labels, setLabels] = useState([]);
  const [showLabel, setShowLabel] = useState(false);
  const [labelDetails, setLabelDetails] = useState([]);
  const [RequestCategoryName, setRequestCategoryName] = useState("");
  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState(
    Array(
      scheduleUpdatedData?.[GlobalConfiguration.lengthCheckZero]?.logs
        ?.length || 0,
    ).fill(false),
  );
  const [currentAccountDetails, setcurrentAccountDetails] = useState({
    bankAccountName: "",
    beneAccountId: "",
    bankAccountIFSC: "",
    bankAccountNo: "",
    categories: "",
    categoryId: "",
    requested_amount: "",
    settleType: "",
    bankLogo: "",
    pan: "",
    ownerId: null,
    ownerAccountName: "",
    ownerBankIFSC: null,
    ownerBankBalance: GlobalConfiguration.lengthCheckZero,
    ownerBankLogo: null,
    ownerLastUpdated: null,
    ownerBankAccountNo: null,
    selectedCategory: null,
    mergeCategory: null,
    amountWords: "",
    labels: [],
    ownerLabels: [],
    comment: "",
    date: "",
    expenseType: "",
    description: "",
    uploadFile: "",
  });
  const [btnClicked, setbtnClicked] = useState({});
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(
    flow === "request_additional"
      ? GlobalConfiguration.lengthCheckTwo
      : GlobalConfiguration?.lengthCheckZero,
  );
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [animationClass, setAnimationClass] = useState("");
  const [tooltip, setTooltip] = useState("Copy to clipboard");
  const copyTextRef = useRef(null);

  const handleSupportIdCopy = async (id) => {
    try {
      await navigator.clipboard.writeText(id);
      setTooltip("Copied");

      clearTimeout(copyTextRef.current);

      copyTextRef.current = setTimeout(() => {
        setTooltip("Copy to clipboard");
      }, IntervalConfiguration.intervalMedium);
    } catch (error) {
      console.error(error);
    }
  };

  //  useSelector
  const services = useSelector((state) => state.refreshToken.services);
  const {
    fieldForceRequestDetailsData,
    requestTxnRejectLoading,
    requestTxnRejectError,
  } = useSelector((s) => s.fieldForceRequest);

  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction({
      path: `/field_force_transaction_dashboard/field_force_request_view_all/field_force_request_detail_page/${field_force_request_id}`,
    });
  };

  //  Constants (hooks / derived)
  const categoryMapper = useCategories();
  const hasModService = services?.includes("AFieldForceRequest");
  const requestDetails =
    fieldForceRequestDetailsData?.request?.[
      GlobalConfiguration.lengthCheckZero
    ];
  const hasTransactionDetails =
    requestDetails?.lifecycle_status === "approved" ||
    Boolean(
      requestDetails?.field_force_transactions_details
        ?.field_force_transaction_id,
    );
  const activeDetailTab =
    selectedDetail === "Transaction details" && hasTransactionDetails
      ? "Transaction details"
      : selectedDetail === "Support details"
        ? "Support details"
        : "Category specific details";
  useEffect(() => {
    if (isloading || !fieldForceRequestDetailsData?.request?.length) {
      return;
    }

    if (flow !== "request_additional" && !hasTransactionDetails) {
      setSelectedDetail("Category specific details");
      setTabIndex(GlobalConfiguration.lengthCheckOne);
    }
  }, [fieldForceRequestDetailsData, flow, hasTransactionDetails, isloading]);

  //useLayoutEffect
  useLayoutEffect(() => {
    if (!leftContentRef.current) return;

    const updateHeight = () => {
      setRightHeight(leftContentRef?.current?.offsetHeight);
    };

    updateHeight();

    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [scheduleUpdatedData]);

  //useEffect
  useEffect(() => {
    return () => {
      dispatch(clearrequestTxnError());
    };
  }, []);

  // Callbacks
  const toggleAdditionalDetails = () => {
    setSelectedDetail("Support details");
    setTabIndex(GlobalConfiguration?.lengthCheckTwo);
    setShowDetails(false);
    setShowLabel(false);
  };

  const toggleCategorySpecificDetails = () => {
    setSelectedDetail("Category specific details");
    setShowDetails(true);
    setTabIndex(GlobalConfiguration?.lengthCheckOne);

    setShowLabel(false);
  };
  const toggleTransactionDetails = () => {
    setSelectedDetail("Transaction details");
    setShowDetails(true);
    setTabIndex(GlobalConfiguration?.lengthCheckZero);

    setShowLabel(false);
  };

  const handleBeneAccModalClose = () => {
    setShowRequestAccModal(false);
  };

  useLayoutEffect(() => {
    if (tabIndex !== prevIndex) {
      const direction =
        tabIndex > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(tabIndex);
    }
  }, [tabIndex]);

  const handleInputChange = (event) => {
    const value = event.target.value;

    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

    const limitedValue = sanitizedValue.slice(
      GlobalConfiguration.lengthCheckZero,
      RejectReasonLength.lengthOfDecline,
    );

    setDeclineReason(limitedValue);
  };

  const handleConfirm = async (id, AccountIdData) => {
    setShowLoader(true);
    setInputDisabled(true);
    setShowRejectPrompt(false);
    CommonToast({
      text: "Request rejecting",
      icon: ICONS.INFO_FILLED,
      variant: "var(--processing)",
    });
    try {
      if (!requestTxnRejectLoading) {
        const result = await dispatch(
          fieldforcerequestTxnReject({ request_ids: [id], AccountIdData }),
        );

        // 3. Wait for the required interval
        await new Promise((resolve) =>
          setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
        );

        if (result?.payload?.status === false) {
          const error_msg =
            result?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
              ?.errors ||
            result?.payload?.errors?.bank_account_number?.[
              GlobalConfiguration.lengthCheckZero
            ] ||
            result?.payload?.errors?.category?.[
              GlobalConfiguration.lengthCheckZero
            ] ||
            "An unknown error occurred.";

          CommonToast({
            text: error_msg,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
          });
        } else {
          CommonToast({
            text: "Request rejected successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
          });

          await dispatch(
            getSpecificFieldForceRequest(field_force_request_id || id),
          );
        }
      }
    } catch (error) {
      console.error("Critical Rejection Error:", error);
      CommonToast({ text: "System error occurred", variant: "var(--error)" });
    } finally {
      setShowLoader(false);
      setInputDisabled(false);
      setDeclineReason("");
      setbtnClicked((prev) => ({
        ...prev,
        [id]: "none",
      }));
    }
  };

  const renderDetailSection = () => {
    if (isloading) return null;

    if (!fieldForceRequestDetailsData?.request?.length) {
      return (
        <div className="text-text-secondary text-font-sm p-padding-md">
          No transaction data available.
        </div>
      );
    }

    switch (tabIndex) {
      case GlobalConfiguration?.lengthCheckZero: {
        if (!hasTransactionDetails) return null;

        return (
          <div
            key={tabIndex}
            className={animationClass}
          >
            <div className="flex flex-col lg:flex-row items-start gap-gap-md pb-padding-md text-text-primary px-padding-md lg:px-padding-base">
              <CommonDetailCard
                cardTitle="Transaction details"
                variant="third"
                numCols={GlobalConfiguration.lengthCheckOne}
                entries={[
                  {
                    heading: TEXT?.SOURCE_ACCOUNT,
                    content:
                      formatAccountNumber(
                        requestDetails?.owner_account_bank_acc_no,
                      ) || "N/A",
                    type: "text",
                    onClick: () => {
                      if (isPopup) {
                        actionRestricted();
                        return;
                      }

                      if (!services?.includes("VAccount")) {
                        navigate("/feature_not_assigned", {
                          state: { unavailableService: "VAccount" },
                        });
                        return;
                      }

                      setOwnerDetailpop(true);
                    },
                  },
                  {
                    heading: TEXT?.IFSC_CODE,
                    content: (
                      <>
                        <span>
                          {requestDetails?.owner_account_ifsc_code || "N/A"}
                        </span>
                        <div className="absolute flex items-center right-[var(--top-sm)] top-[var(--home-txn-slider-slide-step)]">
                          <CommonBankLogo
                            ifsc={requestDetails?.owner_account_ifsc_code}
                            variant="small"
                            type="pill"
                          />
                        </div>
                      </>
                    ),
                    type: "text",
                  },
                  {
                    heading: "Payment method",
                    content: requestDetails?.payment_method || "N/A",
                    type: "text",
                  },
                ]}
              />
            </div>
          </div>
        );
      }
      case GlobalConfiguration?.lengthCheckOne: {
        const allAdditionalData = fieldForceRequestDetailsData.request.flatMap(
          (txn) => txn.additional_data?.data ?? [],
        );

        const attachments = allAdditionalData.filter((item) =>
          ["hyperlink", "upload"].includes(item.data_type),
        );

        const filteredItems = allAdditionalData.filter(
          (item) => !["hyperlink", "upload"].includes(item.data_type),
        );

        const attachmentEntries = attachments
          .map((obj) => {
            if (obj.data_type === "hyperlink" && obj.value) {
              return { heading: "URL", content: obj.value, type: "link" };
            }
            if (obj.data_type === "upload") {
              const file = obj.value;
              if (!file?.metadata) return null;
              const mt = (
                file.metadata.mime_type ?? "application/octet-stream"
              ).toLowerCase();
              const isImage = ["image/png", "image/jpeg", "image/jpg"].includes(
                mt,
              );
              return {
                heading: isImage ? "Image" : "File",
                type: isImage ? "image" : "file",
                content: {
                  fileName: file.metadata.filename,
                  size: file.metadata.size ?? "0",
                  mimeType: mt,
                  url: file.file_url || file.id,
                },
              };
            }
            return null;
          })
          .filter(Boolean);

        if (!filteredItems.length && !attachmentEntries.length) {
          return (
            <div
              key={tabIndex}
              className={animationClass}
            >
              <div className="w-details-card-md Qlg:ml-margin-base ml-margin-md flex flex-col p-padding-md gap-gap-md bg-primary-card rounded-border-radius-md">
                <div className="text-text-primary text-font-sm font-semibold">
                  {TEXT?.CATEGORY_SPECIFIC_DETAILS}
                </div>
                <p className="text-text-secondary text-font-xs font-normal">
                  Support details are not supported for the selected category.
                </p>
              </div>
            </div>
          );
        }

        return (
          <div
            key={tabIndex}
            className={animationClass}
          >
            <div className="flex flex-col lg:flex-row items-start gap-gap-md pb-padding-md text-text-primary px-padding-md lg:px-padding-base">
              {!!filteredItems.length && (
                <CommonDetailCard
                  cardTitle={TEXT?.CATEGORY_SPECIFIC_DETAILS}
                  variant="third"
                  numCols={
                    !attachmentEntries.length &&
                    filteredItems.length > GlobalConfiguration.lengthCheckOne
                      ? GlobalConfiguration.lengthCheckThree
                      : filteredItems?.length ===
                          GlobalConfiguration.lengthCheckOne
                        ? GlobalConfiguration.lengthCheckOne
                        : GlobalConfiguration.lengthCheckTwo
                  }
                  entries={filteredItems
                    .map((item) => {
                      if (item.data_type === "from_year_to_year") {
                        const { from, to } = item.value || {};
                        return {
                          heading: item.name,
                          content: from && to ? `${from} - ${to}` : "Not given",
                          type: "text",
                        };
                      }
                      if (item.data_type === "date_range") {
                        const { start_date, end_date } = item.value || {};
                        return {
                          heading: item.name,
                          content:
                            start_date && end_date
                              ? `${start_date} - ${end_date}`
                              : "Not given",
                          type: "text",
                        };
                      }
                      if (item.data_type === "multi_select_list") {
                        return {
                          heading: item.name,
                          content: item.value?.length
                            ? item.value.join(", ")
                            : "Not given",
                          type: "text",
                        };
                      }
                      if (item.data_type === "toggle") {
                        return {
                          heading: item.name,
                          content: item.value ? "Yes" : "No",
                          type: "text",
                        };
                      }
                      return {
                        heading: item.name,
                        content: item?.value ? item?.value : "Not given",
                        type: "text",
                      };
                    })
                    .filter(Boolean)}
                />
              )}

              {attachmentEntries.length >
                GlobalConfiguration?.lengthCheckZero && (
                <CommonDetailCard
                  cardTitle={globalText?.ATTACHMENTS}
                  numCols={GlobalConfiguration?.lengthCheckOne}
                  variant="third"
                  entries={attachments.map((obj, index) => {
                    switch (obj.data_type.toLowerCase()) {
                      case "hyperlink":
                        return {
                          content: obj?.value ?? "#",
                          heading: "URL",
                          type: "link",
                        };
                      default: {
                        let ob = obj.value;
                        const mt =
                          ob?.metadata?.mime_type ?? "application/octet-stream";
                        switch (true) {
                          case mt?.startsWith("image/"):
                            return {
                              content: {
                                fileName: ob?.metadata?.filename,
                                size: ob?.metadata?.size ?? "0",
                                mimeType: mt,
                                url: ob?.file_url,
                                onUrlClick: () => {
                                  setOpenImageUrl(true);
                                  setSelectedImage({
                                    name: ob?.metadata?.filename,
                                    url: ob?.file_url,
                                  });
                                },
                              },
                              heading: ob?.metadata?.filename || "Image",
                              type: "image",
                            };
                          default:
                            return {
                              content: {
                                fileName: ob?.metadata?.filename,
                                size: ob?.metadata?.size ?? "0",
                                mimeType: mt,
                                onUrlClick: () => {
                                  window.open(ob?.file_url, "_blank").focus();
                                },

                                url: ob?.file_url,
                              },
                              heading: ob?.metadata?.filename || "File",
                              type: "file",
                            };
                        }
                      }
                    }
                  })}
                />
              )}
            </div>
          </div>
        );
      }
      // ===================== SUPPORT DETAILS =====================
      case GlobalConfiguration?.lengthCheckTwo:
        return fieldForceRequestDetailsData?.request?.map((account) => {
          const originItemList = [
            {
              heading: "Requested by",
              content:
                (account?.logs?.[GlobalConfiguration?.lengthCheckZero]
                  ?.first_name || "") +
                " " +
                (account?.logs?.[GlobalConfiguration?.lengthCheckZero]
                  ?.last_name || ""),
              type: "text",
            },
            {
              heading: "Requested on",
              content: formatDateViewAll(
                fieldForceRequestDetailsData?.request?.[
                  GlobalConfiguration?.lengthCheckZero
                ]?.created_on,
                true,
                true,
              ),
              type: "text",
            },
          ];

          if (account?.created_via) {
            originItemList.push({
              heading: "Created via",
              content: account.created_via,
              type: "text",
            });
          }

          const supportItemList = [
            {
              content: account?.request_id,
              heading: "Request ID",
              type: "textWithButton",
              iconArray: [
                {
                  onClick: (e) => handleSupportIdCopy(account?.request_id),
                  title: tooltip,
                  icon:
                    tooltip === "Copied"
                      ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                      : ICONS?.COPY,
                },
              ],
            },
          ];

          if (account.uploaded_file_data) {
            const file = account.uploaded_file_data;
            const mimeType =
              file.metadata?.mime_type ?? "application/octet-stream";

            const isImage = ["image/png", "image/jpeg", "image/jpg"].includes(
              mimeType.toLowerCase(),
            );
          }

          const rejectionItemList = [
            {
              heading: "Rejected by",
              content:
                account?.logs?.[GlobalConfiguration?.lengthCheckOne]
                  ?.user_full_name || "",
              type: "text",
            },
            {
              heading: "Rejected on",
              content: formatDateViewAll(account?.rejected_at, true, true),
              type: "text",
            },
          ];

          const approvalDetailsItemList = [
            {
              heading: "Approved by",
              content:
                account?.logs?.[GlobalConfiguration?.lengthCheckOne]
                  ?.user_full_name || "",
              type: "text",
            },
            {
              heading: "Approved on",
              content: formatDateViewAll(account?.approved_at, true, true),
              type: "text",
            },
          ];

          return (
            <div
              key={tabIndex}
              className={animationClass}
            >
              <div
                key={account.request_id}
                className="flex flex-col lg:flex-row mb-margin-md px-padding-md lg:px-padding-base gap-gap-md"
              >
                <CommonDetailCard
                  cardTitle={TEXT?.ORIGIN_DETAILS}
                  variant="third"
                  numCols={GlobalConfiguration?.lengthCheckOne}
                  entries={originItemList}
                />
                <CommonDetailCard
                  cardTitle={TEXT?.SUPPORT_DETAILS}
                  variant="third"
                  numCols={GlobalConfiguration?.lengthCheckOne}
                  entries={supportItemList}
                />
                {account?.lifecycle_status === "rejected" && (
                  <CommonDetailCard
                    cardTitle={TEXT?.REJECTION_DETAILS}
                    variant="third"
                    numCols={GlobalConfiguration?.lengthCheckOne}
                    entries={rejectionItemList}
                  />
                )}

                {account?.lifecycle_status === "approved" && (
                  <CommonDetailCard
                    cardTitle={TEXT?.APPROVAL_DETAILS}
                    variant="third"
                    numCols={GlobalConfiguration?.lengthCheckOne}
                    entries={approvalDetailsItemList}
                  />
                )}
              </div>
            </div>
          );
        });
      default:
        return null;
    }
  };

  useEffect(() => {
    dispatch(disableSwitcher());
  }, [services, id, navigate]);

  useEffect(() => {
    fetchData();
    const availableLabels = sessionStorage?.getItem("AvailableLabelsRequest");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [id, field_force_request_id]);

  useEffect(() => {
    if (
      Array.isArray(scheduleUpdatedData?.request) &&
      scheduleUpdatedData.request.length
    ) {
      const data =
        scheduleUpdatedData.request[GlobalConfiguration.lengthCheckZero];
      if (type === "reimbursereq_details") {
        if (data?.request_id !== field_force_request_id) return;
      } else {
        if (data?.request_id !== id) return;
      }
      setDoneBinding(true);
    }
  }, [scheduleUpdatedData, id]);

  const categoryIcon = categoryMapper(
    fieldForceRequestDetailsData?.request?.[GlobalConfiguration.lengthCheckZero]
      ?.category_id?.category_id,
  );

  // useEffect(() => {
  //   if (showTLModal || showRejectPrompt || showRequestAccModal) {
  //     document.body.style.overflow = "hidden";
  //   } else {
  //     document.body.style.overflow = "auto";
  //   }
  //   return () => {
  //     document.body.style.overflow = "auto";
  //   };
  // }, [showTLModal, showRejectPrompt, showRequestAccModal]);
  // useEffect(() => {
  //   const el = document.querySelector(".main_div");
  //   el?.scrollTo({ top: 100, behavior: "smooth" });
  // }, []);

  const quickActions = (
    <>
      <div className="flex flex-col w-width-full my-margin-md">
        <div className="py-padding-sm px-padding-md bg-primary-card text-font-sm text-text-primary text-left font-semibold w-width-full">
          Quick Action
        </div>

        {(() => {
          const buttonsTop = [];
          const buttonsBottom = [];

          if (
            scheduleUpdatedData?.request?.[GlobalConfiguration.lengthCheckZero]
              ?.lifecycle_status === "approved"
          ) {
            buttonsTop.push(
              <TopNavSmallButton
                btnText={
                  <>
                    Linked <br /> transaction
                  </>
                }
                icon={ICONS?.LINKED_WHITE_CIRCLE}
                hoverOption={"white"}
                enabledBgColor={"var(--primary-nav-act)"}
                enabledTextColor={"var(--text-primary)"}
                disabledBgColor={"var(--primary-nav-act)"}
                disabledTextColor={"var(--text-primary)"}
                fullWidthRequired
                handleFunction={() => {
                  navigate(
                    `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${scheduleUpdatedData?.request?.[GlobalConfiguration.lengthCheckZero]?.field_force_transactions_details?.field_force_transaction_id}`,
                    {
                      state: {
                        requestData:
                          scheduleUpdatedData?.request?.[
                            GlobalConfiguration.lengthCheckZero
                          ],
                      },
                    },
                  );
                }}
                isDisabled={isPopup}
              />,
            );
          }

          buttonsBottom.push(
            <TopNavSmallButton
              btnText={
                fieldForceRequestDetailsData?.request?.[
                  GlobalConfiguration.lengthCheckZero
                ]?.category_id?.category_name
              }
              btnType="button"
              icon={categoryIcon?.url}
              imgColor={categoryIcon?.colour}
              handleFunction={() => {
                if (isPopup) {
                  actionRestricted();
                  return;
                } else {
                  setRequestHistory(true);
                  setRequestCategoryName(
                    fieldForceRequestDetailsData?.request?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.category_id?.category_name,
                  );
                  setRequestAccName(
                    fieldForceRequestDetailsData?.request?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.field_force_account_name,
                  );
                  setRequestId(
                    fieldForceRequestDetailsData?.request?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.field_force_account_id,
                  );
                }
              }}
              isDisabled={isPopup ? true : false}
              enabledTextColor="var(--text-primary)"
              enabledBgColor="var(--primary-nav-act)"
              disabledBgColor="var(--primary-nav-act)"
              hoverOption="white"
              fullWidthRequired={true}
            />,
          );

          return (
            <>
              <div
                className={`grid w-width-full bg-primary-nav ${
                  buttonsTop.length === GlobalConfiguration?.lengthCheckOne
                    ? "grid-cols-1"
                    : "grid-cols-2"
                } border-b ${
                  buttonsBottom.length > GlobalConfiguration?.lengthCheckZero
                    ? "border-primary-bg"
                    : "border-none"
                }`}
              >
                {buttonsTop.map((btn, index) => (
                  <div
                    key={index}
                    className="relative border-r border-primary-bg last:border-none"
                  >
                    {btn}
                  </div>
                ))}
              </div>

              {/* Bottom Row (Confidential full width if exists) */}
              {buttonsBottom.length > GlobalConfiguration?.lengthCheckZero && (
                <div className=" w-width-full bg-primary-nav">
                  {buttonsBottom.map((btn, index) => (
                    <div
                      key={index}
                      className="relative border-r border-primary-bg last:border-none"
                    >
                      {btn}
                    </div>
                  ))}
                </div>
              )}
            </>
          );
        })()}
      </div>
    </>
  );

  async function fetchData() {
    setIsLoading(true);
    try {
      let response;

      response = await dispatch(
        getSpecificFieldForceRequest(field_force_request_id || id),
      );

      setLabelDetails(
        response?.payload?.request?.[GlobalConfiguration.lengthCheckZero]
          ?.labels || [],
      );
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("/*");
      }
    } catch (error) {
      error("Failed to load the account details", error);
    } finally {
      setIsLoading(false);
    }
  }

  const closeHistory = () => {
    setRequestHistory(false);
    setRequestAccName("");
    setRequestId("");
    setRequestCategoryName("");
  };

  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });

    if (!openApprovalTimeline[index]) {
      setTimeout(() => {
        cardRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, IntervalConfiguration.intervalExtraSmall);
    }
  };
  const handleTimelinePopup = () => {
    SetopenTimelinePopup(true);
    setShowApprovalTimeline(true);
  };
  const PopupcloseIcons = () => {
    setOpenApprovalTimeline([]);
    SetopenTimelinePopup(false);
    setShowApprovalTimeline(false);
  };
  const renderApprovalData = (obj) => {
    return Object.keys(obj).map((key, index, array) => {
      const isLastItem =
        index === array.length - GlobalConfiguration?.lengthCheckZero;
      if (key !== "action") {
        return (
          <>
            <div
              key={key}
              className={`flex flex-row items-center ${
                !isLastItem ? "mb-margin-md" : ""
              }`}
            >
              <div className="w-icon-xs border-b-border border-solid border-text-secondary"></div>

              <p
                key={key}
                className="w-width-full text-text-secondary text-sm text-left font-normal ml-margin-xs make-first-letter-small break-words"
              >{`"${key}": "${obj[key]}"`}</p>
            </div>
          </>
        );
      }
      return null;
    });
  };

  useEffect(() => {
    if (!fieldForceRequestDetailsData) return;

    const uiState = addLifeCycleStatus({
      lifecycle_status:
        fieldForceRequestDetailsData?.request?.[
          GlobalConfiguration.lengthCheckZero
        ]?.lifecycle_status,
      services,
      previousStatus: previousStatus,
      cardType: "single",
    });

    const newData = {
      ...fieldForceRequestDetailsData,
      transaction: fieldForceRequestDetailsData?.request?.map((account) => ({
        ...account,
        loading: false,
        error: false,
        message: "",
        last_updated_user_id_check: false,
        ...uiState,
      })),
    };

    // setTimelinedatabottom(newData);

    setScheduleUpdatedData(newData);

    setDoneBinding(true);
  }, [fieldForceRequestDetailsData, services]);
  const rejectErrorMessage =
    requestTxnRejectError?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
      ?.errors;
  const topApprovedAmount =
    scheduleUpdatedData?.request?.[GlobalConfiguration.lengthCheckZero]
      ?.lifecycle_status === "approved" &&
    scheduleUpdatedData?.request?.[GlobalConfiguration.lengthCheckZero]
      ?.approved_amount !== null &&
    scheduleUpdatedData?.request?.[GlobalConfiguration.lengthCheckZero]
      ?.approved_amount !== undefined &&
    scheduleUpdatedData?.request?.[GlobalConfiguration.lengthCheckZero]
      ?.approved_amount !== ""
      ? `INR ${formatCurrency(scheduleUpdatedData?.request?.[GlobalConfiguration.lengthCheckZero]?.approved_amount)}`
      : "N/A";
  const topApprovedAmountColor =
    topApprovedAmount === "N/A" ? "text-primary" : "settled";
  return (
    <>
      <>{RestrictedActionPopup}</>
      {/* GLOBAL FULL-SCREEN LOADER */}
      {showLoader && (
        <div className="fixed inset-0 w-screen h-screen flex items-center justify-center z-[9999] bg-custom-backdrop bg-opacity-dark-opacity">
          {/* <div className="flex justify-center items-center">
            <Loader />
          </div> */}
        </div>
      )}
      <div
        className={`  flex flex-col overflow-x-hidden  ${!isPopup ? "overflow-y-auto  h-screen" : "h-full"}`}
      >
        {RequestHistory && (
          <>
            <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
              <FieldForceRequestViewAllPopup
                closeFfTxnDetailsModal={closeHistory}
                TxnHistoryid={requestId}
                TxnHistoryAccountName={RequestAccName}
                categoryName={RequestCategoryName}
                type={"requestViewallPopup"}
              />
            </div>
          </>
        )}
        {OwnerDetailpop && (
          <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-Primary-black bg-opacity-dark-opacity">
            <OwnerAccountDetailsPopUp
              closeBeneAccountDetailModal={() => {
                setOwnerDetailpop(false);
              }}
              Remibursement_owneraccount_id={
                fieldForceRequestDetailsData?.request?.[
                  GlobalConfiguration.lengthCheckZero
                ]?.owner_account_id
              }
              type={"reimburseowner_details"}
            />
          </div>
        )}
        {ReimburseAccountDetailpop && (
          <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-Primary-black bg-opacity-dark-opacity">
            <FieldForceAccountDetailsPopup
              closeBeneAccountDetailModal={() => {
                setReimburseAccountDetailpop(false);
              }}
              field_force_account_id={BeneAccountId}
            />
          </div>
        )}
        {showRejectPrompt && (
          <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
            <SmallPopupWithBulletPoints
              inputAdornment={false}
              headerTitle={TEXT?.REJECT_REASON_REQ_TITLE}
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              textSize="font-md"
              subtext={TEXT?.PROVIDE_REJECT_REQUEST_REASON_PROMPT}
              noteText={TEXT?.MINIMUM_TEN_CHARACTER_REQUIRED_MGS}
              isTextInputField={true}
              inputPlaceholder="Reason"
              subtextwithbullet="Y"
              bulletPoints={[
                "Once rejected, a new request should be created and no transaction will be initiated.",
                "The user needs to create a new request.",
              ]}
              inputVariant={
                declineReason &&
                declineReason.length > GlobalConfiguration.accountnormalLength
                  ? "verified"
                  : declineReason &&
                      declineReason.length <
                        GlobalConfiguration.owneraccountnormalLength
                    ? "typing"
                    : "default"
              }
              inputIsDisabled={showLoader ? true : false}
              btnOneIsDisabled={showLoader}
              inputBgColor="var(--primary-bg)"
              inputFgColor="var(--text-secondary)"
              inputOnInput={(e) => {
                if (!showLoader) {
                  handleInputChange(e);
                }
              }}
              inputValue={declineReason}
              inputFontKind="big"
              inputIsFullWidth={true}
              btnOneText="Cancel"
              btnOneHandleFunction={() => {
                if (!showLoader) {
                  setbtnClicked((prev) => ({
                    ...prev,
                    [fieldForceRequestDetailsData?.request?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.request_id]: "none",
                  }));
                  setShowRejectPrompt(false);
                  setDeclineReason("");

                  setbtnClicked((prev) => ({
                    ...prev,
                    [fieldForceRequestDetailsData?.request?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.request_id]: "none",
                  }));
                }
              }}
              btnOneEnabledBgColor="var(--primary-bg)"
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneHoverOption="white"
              btnTwoText="Reject"
              btnTwoHandleFunction={() => {
                handleConfirm(
                  fieldForceRequestDetailsData?.request?.[
                    GlobalConfiguration.lengthCheckZero
                  ]?.request_id,
                  declineReason,
                );
              }}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={
                !declineReason ||
                declineReason.length <
                  GlobalConfiguration.owneraccountnormalLength
              }
              btnTwoDisabledBgColor="var(--text-disabled)"
              btnTwoIsLoaderNeeded={showLoader ? true : false}
              btnTwoIsLoading={showLoader ? true : false}
              btnTwoHoverOption="black"
              btnTwoInActiveVariantNeeded={true}
            />
          </div>
        )}
        {openImageUrl && (
          <>
            <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
              <MediumImagePopup
                image={selectedImage}
                closehandleFunction={() => {
                  setOpenImageUrl(false);
                }}
              />
            </div>
          </>
        )}
        {opentimelinepopup && (
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle="Request Timeline"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headertextSize="font-md"
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={PopupcloseIcons}
              closeicon={ICONS?.CLOSE}
              closeiconhoverOption="white"
              closeiconbtnType="button"
              closeiconisDisabled={false}
              closeicondisabledBgColor=""
              closeiconbuttonRef={null}
              closeicontitle="Close"
              btnType="button"
              handleFunction={() => {}}
              enabledBgColor="var(--positive-act)"
              hoverOption="dark"
              outLineColor=""
              enabledTextColor="var(--text-primary)"
              fullWidthRequired={false}
              isDisabled={false}
              disabledTextColor=""
              disabledBgColor=""
              isLoading={false}
              buttonRef={null}
              inActiveVariantNeeded={false}
              isLoaderNeeded={false}
              isscrollRequired={true}
            >
              <TimelinePopupContent
                logsData={scheduleUpdatedData?.transaction}
                handleApprovalClick={handleTimelinePopup}
                showDistributionRightIcon={false}
                showApprovalLeftIcon={false}
                showApprovalTimeline={showApprovalTimeline}
                openApprovalTimeline={openApprovalTimeline}
                handleApprovalTimeline={handleApprovalTimeline}
                setOpenApprovalTimeline={setOpenApprovalTimeline}
                cardType={"single"}
                popUpMode={true}
              />
            </LargePopupRedirect>
          </div>
        )}
        {showRequestAccModal && (
          <div
            className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-custom-backdrop bg-opacity-dark-opacity"
            onClick={() => {
              handleBeneAccModalClose();
            }}
          >
            <div onClick={(e) => e.stopPropagation()}>
              <FieldForceAccountDetailsPopup
                field_force_account_id={
                  fieldForceRequestDetailsData?.request?.[
                    GlobalConfiguration.lengthCheckZero
                  ]?.field_force_account_id
                }
                closeBeneAccountDetailModal={handleBeneAccModalClose}
                type={"fieldforceacc_details"}
                payload={{
                  bene_account_id:
                    fieldForceRequestDetailsData?.request?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.field_force_account_id,
                }}
                // Add this line to pass the state updater to the popup wrapper
                setScheduleUpdatedData={setScheduleUpdatedData}
              />
            </div>
          </div>
        )}
        {!isPopup && (
          <>
            <div className="sched-mobile-nav-bar fixed top-top-base left-left-base mt-margin-base w-width-full z-z-index-overlay bg-primary-nav shadow-box-shadow-bottom lg:hidden block">
              <div
                className="px-padding-md py-padding-sm  flex flex-row items-center gap-gap-sm"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <div className=" mt-margin-xs cursor-pointer pt-px">
                  <SVGComponent
                    url={ICONS?.ARROW_LEFT_WHITE}
                    color="var(--text-primary)"
                    height={"var(--icon-sm)"}
                    width={"var(--icon-sm)"}
                  />
                </div>

                <div className="flex flex-col justify-center items-start">
                  <div className="text-font-md text-text-primary font-normal font-sans">
                    Field force
                  </div>
                  <div className="text-font-xs text-text-secondary font-normal font-sans">
                    Request detail
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {alertPopUp && (
          <div className="fixed top-top-base left-left-base w-width-full h-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <FullScreen
              id={txn_id ?? ""}
              setAlertPopUp={setAlertPopUp}
              type={"Schedule_Internal_Txn"}
            />
          </div>
        )}
        {!isPopup && (
          <div className="Qsmd:h-navbar-breadcrumb-height h-navbar-height bg-primary-nav hidden flex-shrink-0 Qmd:block"></div>
        )}

        {isloading ? (
          <div className="w-width-full flex-1 flex flex-row justify-center items-center">
            <Loader />
          </div>
        ) : (
          <>
            <div className={`bg-primary-bg`}>
              <>
                {/* Desktop  */}
                <div className="sched-detail-section hidden bg-primary-nav Qmd:flex flex-row justify-center relative">
                  <div
                    className={`sched-detail-section-inner-1024 Qlg:max-w-tab-width-normal Qlg:w-std-width Qmd:w-width-full relative `}
                  >
                    {/* 1st part  */}
                    <div className="flex h-auto justify-between">
                      <div className="flex flex-1 justify-between sched-schedule-name-div items-center py-padding-md">
                        <div className="pl-padding-sm">
                          <TitleSubtitlePair
                            title={`INR ${formatCurrency(scheduleUpdatedData?.request?.[GlobalConfiguration.lengthCheckZero]?.requested_amount)}`}
                            titleColor={
                              scheduleUpdatedData?.request?.[
                                GlobalConfiguration.lengthCheckZero
                              ]?.requested_amount ===
                              scheduleUpdatedData?.request?.[
                                GlobalConfiguration.lengthCheckZero
                              ]?.approved_amount
                                ? "text-primary"
                                : "queued"
                            }
                            subtitle={"Requested amount"}
                            info={false}
                            alignRight={false}
                            hoverOption="white"
                            isBold={true}
                            variant="md"
                          />
                        </div>
                        <div className="pl-padding-sm">
                          <TitleSubtitlePair
                            title={topApprovedAmount}
                            titleColor={topApprovedAmountColor}
                            subtitle={"Approved amount"}
                            info={false}
                            textAlign={"right"}
                            hoverOption="white"
                            isBold={true}
                            variant="md"
                          />
                        </div>
                      </div>

                      <div className="border-r border-solid border-primary-bg mx-margin-md my-margin-md h-icon-xl"></div>

                      <div className="flex flex-1 justify-between sched-txn-amount-div">
                        <div className="py-padding-md">
                          <TitleSubtitlePair
                            title={
                              fieldForceRequestDetailsData?.request?.[
                                GlobalConfiguration.lengthCheckZero
                              ]?.field_force_account_name
                            }
                            titleColor="text-primary"
                            subtitle="Account name"
                            info={false}
                            alignRight={false}
                            hoverOption="white"
                            isBold={false}
                            variant="md"
                          />
                        </div>
                        {fieldForceRequestDetailsData?.request?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.lifecycle_status === "approved" ? (
                          <TopNavSmallButton
                            btnText={
                              <>
                                Linked <br /> transaction
                              </>
                            }
                            icon={ICONS?.LINKED_WHITE_CIRCLE}
                            hoverOption={"white"}
                            enabledBgColor={"var(--primary-nav-act)"}
                            enabledTextColor={"var(--text-primary)"}
                            disabledBgColor={"var(--primary-nav-act)"}
                            disabledTextColor={"var(--text-primary)"}
                            handleFunction={() => {
                              navigate(
                                `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${fieldForceRequestDetailsData?.request?.[GlobalConfiguration.lengthCheckZero]?.field_force_transactions_details?.field_force_transaction_id}`,
                                {
                                  state: {
                                    requestData:
                                      fieldForceRequestDetailsData?.request?.[
                                        GlobalConfiguration.lengthCheckZero
                                      ],
                                  },
                                },
                              );
                            }}
                            isDisabled={isPopup}
                          />
                        ) : (
                          <TopNavSmallButton
                            btnText={
                              fieldForceRequestDetailsData?.request?.[
                                GlobalConfiguration.lengthCheckZero
                              ]?.category_id?.category_name
                            }
                            btnType="button"
                            icon={categoryIcon?.url}
                            imgColor={categoryIcon?.colour}
                            handleFunction={() => {
                              if (isPopup) {
                                actionRestricted();
                                return;
                              } else {
                                setRequestHistory(true);
                                setRequestCategoryName(
                                  fieldForceRequestDetailsData?.request?.[
                                    GlobalConfiguration.lengthCheckZero
                                  ]?.category_id?.category_name,
                                );
                                setRequestAccName(
                                  fieldForceRequestDetailsData?.request?.[
                                    GlobalConfiguration.lengthCheckZero
                                  ]?.field_force_account_name,
                                );
                                setRequestId(
                                  fieldForceRequestDetailsData?.request?.[
                                    GlobalConfiguration.lengthCheckZero
                                  ]?.field_force_account_id,
                                );
                              }
                            }}
                            isDisabled={isPopup ? true : false}
                            enabledTextColor="var(--text-primary)"
                            enabledBgColor="var(--primary-nav-act)"
                            disabledBgColor="var(--primary-nav-act)"
                            hoverOption="white"
                            fullWidthRequired={false}
                          />
                        )}
                      </div>
                    </div>
                    {/* 1st part  */}

                    {/* 2nd Part  */}
                    <hr className="border-primary-bg"></hr>
                    {/* 2nd Part  */}

                    {/* 3rd Part  */}

                    {fieldForceRequestDetailsData?.request?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.lifecycle_status === "approved" ? (
                      <div className="flex flex-row justify-center relative">
                        <div className="sched-source-side w-width-full flex flex-col justify-between Qmd:pb-padding-md  Qmd:pt-padding-sm ">
                          <div className="sched-source-acct-bank flex flex-row items-center justify-between w-width-full Qmd:pr-padding-sm">
                            <div className="">
                              <TitleSubtitlePair
                                isDisabled={
                                  isPopup ||
                                  !(
                                    services?.includes("FFVAccount") ||
                                    services?.includes("Admin")
                                  )
                                }
                                alignRight={false}
                                title={formatAccountNumber(
                                  fieldForceRequestDetailsData?.request?.[
                                    GlobalConfiguration.lengthCheckZero
                                  ]?.field_force_account_bank_acc_no,
                                ).toUpperCase()}
                                titleColor={"text-primary"}
                                subtitle={"Destination account"}
                                onClick={() => {
                                  if (isPopup) {
                                    actionRestricted();
                                  } else if (
                                    services?.includes("FFVAccount") ||
                                    services?.includes("Admin")
                                  ) {
                                    setReimburseAccountDetailpop(true);
                                    setBeneAccountId(
                                      fieldForceRequestDetailsData?.request?.[
                                        GlobalConfiguration.lengthCheckZero
                                      ]?.field_force_account_id,
                                    );
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "FFVAccount, Admin",
                                      },
                                    });
                                  }
                                }}
                                info={false}
                                showArrow={true}
                                hoverOption={"white"}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>
                            <div className="sched-dest-bank rounded-full h-icon-lg flex bg-text-primary flex-row items-center px-padding-sm py-padding-button-s justify-end ml-margin-sm">
                              <CommonBankLogo
                                ifsc={
                                  fieldForceRequestDetailsData?.request?.[
                                    GlobalConfiguration.lengthCheckZero
                                  ]?.field_force_account_ifsc_code
                                }
                                variant="big"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="border-r border-solid border-primary-bg mx-margin-md my-margin-md"></div>

                        <div
                          className={`sched-dest-side w-width-full h-fit flex flex-col`}
                        >
                          <div className="sched-dest-acct-bank flex flex-row items-center justify-between w-width-full pl-padding-sm">
                            <TitleSubtitlePair
                              isDisabled={false}
                              alignRight={false}
                              title={
                                fieldForceRequestDetailsData?.request?.[
                                  GlobalConfiguration.lengthCheckZero
                                ]?.field_force_account_ifsc_code || "N/A"
                              }
                              titleColor={"text-primary"}
                              subtitle={TEXT?.IFSC_CODE}
                              info={false}
                              showArrow={false}
                              isBold={false}
                              variant={"md"}
                            />
                            <div className="w-positive-negative-btn-width h-positive-negative-btn-height">
                              <TopNavSmallButton
                                btnText={
                                  fieldForceRequestDetailsData?.request?.[
                                    GlobalConfiguration.lengthCheckZero
                                  ]?.category_id?.category_name
                                }
                                btnType="button"
                                icon={categoryIcon?.url}
                                imgColor={categoryIcon?.colour}
                                handleFunction={() => {
                                  if (isPopup) {
                                    actionRestricted();
                                    return;
                                  }
                                  setRequestHistory(true);
                                  setRequestCategoryName(
                                    fieldForceRequestDetailsData?.request?.[
                                      GlobalConfiguration.lengthCheckZero
                                    ]?.category_id?.category_name,
                                  );
                                  setRequestAccName(
                                    fieldForceRequestDetailsData?.request?.[
                                      GlobalConfiguration.lengthCheckZero
                                    ]?.field_force_account_name,
                                  );
                                  setRequestId(
                                    fieldForceRequestDetailsData?.request?.[
                                      GlobalConfiguration.lengthCheckZero
                                    ]?.field_force_account_id,
                                  );
                                }}
                                isDisabled={isPopup}
                                enabledTextColor="var(--text-primary)"
                                enabledBgColor="var(--primary-nav-act)"
                                disabledBgColor="var(--primary-nav-act)"
                                hoverOption="white"
                                fullWidthRequired={false}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="flex flex-row justify-center relative Qmd:min-h-positive-negative-btn-width">
                        <div className="sched-source-side w-width-full flex flex-col items-center justify-around Qmd:pb-padding-sm Qmd:pt-padding-sm">
                          <div
                            className={`sched-source-acct-bank Qmd:translate-x-[-0.5rem] flex flex-row items-center justify-between w-width-full pl-padding-sm`}
                          >
                            <div
                              className={` ${isPopup && "opacity-dark-opacity"}`}
                            >
                              <TitleSubtitlePair
                                isDisabled={
                                  isPopup ||
                                  !(
                                    services?.includes("FFVAccount") ||
                                    services?.includes("Admin")
                                  )
                                    ? true
                                    : false
                                }
                                alignRight={false}
                                title={formatAccountNumber(
                                  fieldForceRequestDetailsData?.request?.[
                                    GlobalConfiguration.lengthCheckZero
                                  ]?.field_force_account_bank_acc_no,
                                ).toUpperCase()}
                                titleColor={"text-primary"}
                                subtitle={"Destination account"}
                                onClick={() => {
                                  if (isPopup) {
                                    actionRestricted();
                                  } else {
                                    if (
                                      services?.includes("FFVAccount") ||
                                      services?.includes("Admin")
                                    ) {
                                      setReimburseAccountDetailpop(true);
                                      setBeneAccountId(
                                        fieldForceRequestDetailsData?.request?.[
                                          GlobalConfiguration.lengthCheckZero
                                        ]?.field_force_account_id,
                                      );
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService:
                                            "FFVAccount, Admin",
                                        },
                                      });
                                    }
                                  }
                                }}
                                info={false}
                                showArrow={true}
                                hoverOption={"white"}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>

                            <div
                              className={`${isPopup && "opacity-light-opacity"} bg-text-primary rounded-full p-padding-sm flex flex-row justify-center items-center px-padding-sm py-padding-button-s mr-margin-md`}
                            >
                              <CommonBankLogo
                                ifsc={
                                  fieldForceRequestDetailsData?.request?.[
                                    GlobalConfiguration.lengthCheckZero
                                  ]?.field_force_account_ifsc_code
                                }
                                variant="big"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="border-r border-solid border-primary-bg mx-margin-md my-margin-md"></div>
                        <div
                          className={`sched-dest-side w-width-full flex flex-col  ${"justify-around"}`}
                        >
                          <div className="sched-dest-acct-bank flex flex-row items-center justify-between w-width-full h-full">
                            <div className="flex justify-between">
                              <TitleSubtitlePair
                                isDisabled={false}
                                alignRight={false}
                                title={
                                  fieldForceRequestDetailsData?.request?.[
                                    GlobalConfiguration.lengthCheckZero
                                  ]?.field_force_account_ifsc_code
                                }
                                titleColor={"text-primary"}
                                subtitle={TEXT?.IFSC_CODE}
                                info={false}
                                showArrow={false}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {/* 3rd Part  */}
                  </div>
                </div>
                {/* Desktop  */}
                <div
                  className={`h-mobile-navbar-height bg-primary-nav ${isPopup ? "hidden" : "Qmd:hidden block"}`}
                ></div>
                <div className="sched-detail-section-mobile flex flex-col Qmd:hidden w-width-full bg-primary-nav ">
                  <div className="sched-name-mobile flex flex-col p-padding-md">
                    <TitleSubtitlePair
                      title={`INR ${formatCurrency(scheduleUpdatedData?.request?.[GlobalConfiguration.lengthCheckZero]?.requested_amount)}`}
                      titleColor={
                        scheduleUpdatedData?.request?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.requested_amount ===
                        scheduleUpdatedData?.request?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.approved_amount
                          ? "text-primary"
                          : "queued"
                      }
                      subtitle={"Requested amount"}
                      info={false}
                      alignRight={false}
                      hoverOption="white"
                      isBold={true}
                      variant="md"
                    />
                  </div>
                  <hr className="border-primary-bg mx-margin-md Qmd:mx-margin-base"></hr>
                  <div className="sched-name-mobile flex flex-col p-padding-md">
                    <TitleSubtitlePair
                      title={topApprovedAmount}
                      titleColor={topApprovedAmountColor}
                      subtitle={"Approved amount"}
                      info={false}
                      alignRight={false}
                      hoverOption="white"
                      isBold={true}
                      variant="md"
                    />
                  </div>
                  <hr className="border-primary-bg mx-margin-md Qmd:mx-margin-base"></hr>

                  <div className="sched-amount-mobile flex flex-col p-padding-md">
                    <TitleSubtitlePair
                      title={
                        fieldForceRequestDetailsData?.request?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.field_force_account_name || ""
                      }
                      titleColor="text-primary"
                      subtitle="Account name"
                      info={false}
                      alignRight={false}
                      hoverOption="white"
                      isBold={false}
                      variant="md"
                    />
                  </div>
                  <hr className="border-primary-bg mx-margin-md Qmd:mx-margin-base"></hr>

                  <div className="sched-accounts-jumbo-div-mobile flex flex-col Qlg:pl-padding-sm py-padding-sm">
                    {fieldForceRequestDetailsData?.request?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.lifecycle_status === "approved" && (
                      <div className="border-b hidden Qmd:block border-solid border-primary-bg mx-margin-md w-width-full"></div>
                    )}

                    <div
                      className={`sched-detail-src-acct-logo-mobile flex flex-row items-center  ${isPopup && "opacity-light-opacity"} justify-between`}
                    >
                      <div className="ml-margin-sm lg:ml-0">
                        <TitleSubtitlePair
                          isDisabled={
                            isPopup
                              ? true
                              : !(
                                    services?.includes("FFVAccount") ||
                                    services?.includes("Admin")
                                  )
                                ? true
                                : false
                          }
                          alignRight={false}
                          title={formatAccountNumber(
                            fieldForceRequestDetailsData?.request?.[
                              GlobalConfiguration.lengthCheckZero
                            ]?.field_force_account_bank_acc_no,
                          ).toUpperCase()}
                          titleColor={"text-primary"}
                          subtitle={"Destination account"}
                          onClick={() => {
                            if (isPopup) {
                              actionRestricted();
                            } else {
                              if (
                                services?.includes("FFVAccount") ||
                                services?.includes("Admin")
                              ) {
                                setReimburseAccountDetailpop(true);
                                setBeneAccountId(
                                  fieldForceRequestDetailsData?.request?.[
                                    GlobalConfiguration.lengthCheckZero
                                  ]?.field_force_account_id,
                                );
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "FFVAccount, Admin",
                                  },
                                });
                              }
                            }
                          }}
                          info={false}
                          showArrow={true}
                          hoverOption={"white"}
                          isBold={false}
                          variant={"md"}
                        />
                      </div>
                      <div className="bg-text-primary rounded-full p-padding-sm flex flex-row justify-center items-center px-padding-sm py-padding-button-s mr-margin-md">
                        <CommonBankLogo
                          ifsc={
                            fieldForceRequestDetailsData?.request?.[
                              GlobalConfiguration.lengthCheckZero
                            ]?.field_force_account_ifsc_code
                          }
                          variant="big"
                        />
                      </div>
                    </div>
                  </div>

                  <hr className="border-primary-bg mx-margin-md Qmd:mx-margin-base"></hr>
                  <div className="sched-method-mobile flex flex-col gap-gap-xs p-padding-md">
                    <TitleSubtitlePair
                      isDisabled={false}
                      alignRight={false}
                      title={
                        fieldForceRequestDetailsData?.request?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.field_force_account_ifsc_code || "N/A"
                      }
                      titleColor={"text-primary"}
                      subtitle={TEXT?.IFSC_CODE}
                      info={false}
                      showArrow={false}
                      isBold={false}
                      variant={"md"}
                    />
                  </div>
                </div>
              </>

              <div className="block Qmd:hidden">
                {scheduleUpdatedData?.transaction?.map((schedule) => {
                  return (
                    <TimelineStatusBar
                      showMobile={true}
                      overrideAutoLoader
                      whichBtnClicked={
                        btnClicked?.[
                          fieldForceRequestDetailsData?.request?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.request_id
                        ] || "none"
                      }
                      // isLoading={reimbursementRequestDetailsLoading}
                      failedToTakeaction={
                        timelinedatabottom?.message || rejectErrorMessage
                      }
                      failedToTakeactionReason={
                        scheduleUpdatedData?.message || rejectErrorMessage
                      }
                      accountApprovalPending={
                        scheduleUpdatedData?.request?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.field_force_account_approval_status === "pending" &&
                        scheduleUpdatedData?.request?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.lifecycle_status === "pending"
                      }
                      accountApprovalPendingSubHeader={
                        services?.includes("FFAAccount")
                          ? "Account is not approved, approve account before approving transaction."
                          : "To approve the account, please contact the authorized person."
                      }
                      handleApprovalPendingBtn={() => {
                        if (services?.includes("FFAAccount")) {
                          setShowRequestAccModal(true);
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "FFAAccount",
                            },
                          });
                        }
                      }}
                      requestApproval={
                        fieldForceRequestDetailsData?.request?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.approved === "Y"
                      }
                      handleRequestApproval={() => {
                        if (
                          services?.includes("VFieldForceTxn") ||
                          services?.includes("Admin")
                        ) {
                          navigate(
                            `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${scheduleUpdatedData?.request?.[GlobalConfiguration.lengthCheckZero]?.field_force_transactions_details?.field_force_transaction_id}`,
                          );
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "VFieldForceTxn",
                            },
                          });
                        }
                      }}
                      isReqDisable={
                        !services?.includes("VFieldForceTxn") &&
                        !services?.includes("Admin")
                      }
                      isApprovalPendingDisabled={
                        !services?.includes("FFAAccount")
                      }
                      rejected={
                        fieldForceRequestDetailsData?.request?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.rejected === "Y"
                      }
                      rejectedReason={
                        fieldForceRequestDetailsData?.request?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.rejection_reason
                      }
                      pending={
                        !(
                          fieldForceRequestDetailsData?.request?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.approved === "Y"
                        ) &&
                        !(
                          fieldForceRequestDetailsData?.request?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.rejected === "Y"
                        ) &&
                        !rejectErrorMessage
                      }
                      rejectMobClick={() => {
                        if (hasModService) {
                          setbtnClicked((prev) => ({
                            ...prev,
                            [fieldForceRequestDetailsData?.request?.[
                              GlobalConfiguration.lengthCheckZero
                            ]?.request_id]: "Reject",
                          }));
                          setShowRejectPrompt(true);
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AFieldForceRequest",
                            },
                          });
                        }
                      }}
                      isRejectMobDisable={
                        !services?.includes("AFieldForceRequest")
                      }
                      approveBtnText={
                        <>
                          Approve and <br /> pay
                        </>
                      }
                      rejectBtnText={
                        <>
                          Reject <br /> request
                        </>
                      }
                      approveMobClick={() => {
                        if (services?.includes("AFieldForceRequest")) {
                          const updatedAccountDetails = {
                            request_id: schedule?.request_id,
                            bankAccountName: schedule?.field_force_account_name,
                            beneAccountId: schedule?.field_force_account_id,
                            bankAccountIFSC:
                              schedule?.field_force_account_ifsc_code,
                            bankAccountNo:
                              schedule?.field_force_account_bank_acc_no,
                            categories: schedule?.category_id?.category_name,
                            categoryId: schedule?.category_id?.category_id,
                            requested_amount:
                              schedule?.requested_amount || "NA",
                            bankLogo: schedule?.field_force_account_ifsc_code,
                            pan: "",
                            ownerId: null,
                            ownerAccountName: "",
                            ownerBankIFSC: null,
                            ownerBankBalance:
                              GlobalConfiguration.lengthCheckZero,
                            ownerBankLogo: null,
                            ownerLastUpdated: null,
                            ownerBankAccountNo: null,
                            selectedCategory: {
                              configuration: schedule?.additional_data,
                            },
                            mergeCategory: schedule?.additional_data?.data,
                            amountWords: "",
                            labels: schedule?.labels || [],
                            ownerLabels: [],
                            comment: "",
                            // date: schedule?.reimbursement_date,
                            date: schedule?.request_date,
                            expenseType: schedule?.expense_type,
                            description:
                              currentAccountDetails?.description ?? "",
                            uploadFile: schedule?.uploaded_file_data,
                          };

                          setcurrentAccountDetails(updatedAccountDetails);

                          navigate(
                            "/field_force_transaction_dashboard/create_field_force_transaction",
                            {
                              state: {
                                ...updatedAccountDetails,
                                type: "PayFieldForceTxn",
                                flow: "PayFieldForceTxn",
                                TypeRTGS: "RequestRTGS",
                              },
                            },
                          );
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AFieldForceRequest",
                            },
                          });
                        }
                      }}
                      isApproveMobDisable={!hasModService}
                    />
                  );
                })}
              </div>

              <div className="sched-bottom-section flex flex-row justify-center bg-primary-bg">
                <div
                  className={`sched-bottom-section-inner-1024 max-w-screen-Qlg
                   ${
                     fieldForceRequestDetailsData?.request?.[
                       GlobalConfiguration.lengthCheckZero
                     ]?.lifecycle_status === "approved"
                       ? rejectErrorMessage
                         ? "mt-margin-sm"
                         : "mt-margin-md"
                       : fieldForceRequestDetailsData?.request?.[
                             GlobalConfiguration.lengthCheckZero
                           ]?.lifecycle_status === "rejected"
                         ? "mt-margin-md"
                         : fieldForceRequestDetailsData?.request?.[
                               GlobalConfiguration.lengthCheckZero
                             ]?.lifecycle_status === "pending"
                           ? "mt-margin-sm"
                           : "mt-margin-base"
                   }
                    ${!isPopup ? "Qmd:w-max-content-width" : " mr-margin-base "} w-width-full pl-padding-base `}
                >
                  <div className="sched-quick-details-container-mobile block Qmd:hidden">
                    {quickActions}
                  </div>
                  <>
                    <div
                      className={`Qlg:mx-margin-base mx-margin-md flex flex-col Qmd:flex-row mt-margin-md Qmd:items-end max-w-max-content-width Qmd:max-h-max-height-top-slider min-h-stepper-header ${
                        rejectErrorMessage
                          ? "mt-margin-sm"
                          : "Qsmd:mt-margin-base"
                      } ${
                        !(
                          fieldForceRequestDetailsData?.request?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.approved === "Y" ||
                          fieldForceRequestDetailsData?.request?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.rejected === "Y"
                        )
                          ? "Qsmd:justify-center"
                          : "justify-start"
                      }`}
                    >
                      <div
                        className={`bg-primary-card rounded-t-border-radius-md  rounded-bl-border-radius-md w-width-full Qlg:w-[calc(var(--graphic-rectangle-height-lg)-(var(--banklogo-height-sm)))] Qmd:w-width-sm  ${fieldForceRequestDetailsData?.request?.[GlobalConfiguration.lengthCheckZero]?.rejected === "Y" ? "rounded-bl-border-radius-md rounded-br-border-radius-md Qsmd:rounded-br-none" : "Qsmd:rounded-br-none rounded-br-border-radius-md"} ${isPopup ? "mt-margin-md" : ""} `}
                      >
                        <div
                          className={`sched-txn-timeline-status-container ${isPopup && "opacity-light-opacity cursor-not-allowed "} bg-primary-nav relative z-z-index-content rounded-border-radius-md w-width-full ${isPopup ? "cursor-not-allowed" : " "}`}
                        >
                          <div className="text-text-primary text-font-xs text-left font-semibold pt-padding-sm mb-margin-sm px-padding-md">
                            Request Timeline
                          </div>
                          <div className="relative left-left-base border-primary-bg border-t-border mx-margin-md"></div>

                          <div
                            ref={leftContentRef}
                            className={`bg-primary-nav group relative  rounded-b-border-radius-md w-full z-z-index-base`}
                          >
                            <CommonTimeLineCard
                              logsData={scheduleUpdatedData?.transaction}
                              handleApprovalClick={handleTimelinePopup}
                              showApprovalTimeline={true}
                              showDistributionTimeline={false}
                              showDistributionRightIcon={true}
                              showApprovalLeftIcon={true}
                              showApprovalDuration={true}
                              showDistributionDuration={false}
                              isDisabled={isPopup}
                              cardType={"single"}
                              leftCardTitle="Stage - Approval"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="hidden Qmd:flex flex-col flex-grow  w-width-md">
                        {/* Web  */}
                        {scheduleUpdatedData?.transaction?.map((schedule) => {
                          return (
                            <TimelineStatusBar
                              overrideAutoLoader
                              hasDistributionData={false}
                              showMobile={false}
                              // isLoading={reimbursementRequestDetailsLoading}
                              whichBtnClicked={
                                btnClicked?.[
                                  fieldForceRequestDetailsData?.request?.[
                                    GlobalConfiguration.lengthCheckZero
                                  ]?.request_id
                                ] || "none"
                              }
                              failedToTakeaction={
                                timelinedatabottom?.message ||
                                rejectErrorMessage
                              }
                              failedToTakeactionReason={
                                scheduleUpdatedData?.message ||
                                rejectErrorMessage
                              }
                              accountApprovalPending={
                                scheduleUpdatedData?.request?.[
                                  GlobalConfiguration.lengthCheckZero
                                ]?.field_force_account_approval_status ===
                                  "pending" &&
                                scheduleUpdatedData?.request?.[
                                  GlobalConfiguration.lengthCheckZero
                                ]?.lifecycle_status === "pending"
                              }
                              accountApprovalPendingSubHeader={
                                services?.includes("FFAAccount")
                                  ? "Account is not approved, approve account before approving transaction."
                                  : "To approve the account, please contact the authorized person."
                              }
                              handleApprovalPendingBtn={() => {
                                if (services?.includes("FFAAccount")) {
                                  setShowRequestAccModal(true);
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "FFAAccount",
                                    },
                                  });
                                }
                              }}
                              requestApproval={
                                fieldForceRequestDetailsData?.request?.[
                                  GlobalConfiguration.lengthCheckZero
                                ]?.approved === "Y"
                              }
                              handleRequestApproval={() => {
                                if (
                                  services?.includes("VFieldForceTxn") ||
                                  services?.includes("Admin")
                                ) {
                                  navigate(
                                    `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${scheduleUpdatedData?.request?.[GlobalConfiguration.lengthCheckZero]?.field_force_transactions_details?.field_force_transaction_id}`,
                                  );
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "VFieldForceTxn",
                                    },
                                  });
                                }
                              }}
                              isReqDisable={
                                !services?.includes("VFieldForceTxn") &&
                                !services?.includes("Admin")
                              }
                              isApprovalPendingDisabled={
                                !services?.includes("FFAAccount")
                              }
                              rejected={
                                fieldForceRequestDetailsData?.request?.[
                                  GlobalConfiguration.lengthCheckZero
                                ]?.rejected === "Y"
                              }
                              rejectedReason={
                                fieldForceRequestDetailsData?.request?.[
                                  GlobalConfiguration.lengthCheckZero
                                ]?.rejection_reason
                              }
                              pending={
                                !(
                                  fieldForceRequestDetailsData?.request?.[
                                    GlobalConfiguration.lengthCheckZero
                                  ]?.approved === "Y"
                                ) &&
                                !(
                                  fieldForceRequestDetailsData?.request?.[
                                    GlobalConfiguration.lengthCheckZero
                                  ]?.rejected === "Y"
                                ) &&
                                !rejectErrorMessage
                              }
                              rejectClick={() => {
                                setbtnClicked((prev) => ({
                                  ...prev,
                                  [fieldForceRequestDetailsData?.request?.[
                                    GlobalConfiguration.lengthCheckZero
                                  ]?.request_id]: "Reject",
                                }));
                                if (hasModService) {
                                  setShowRejectPrompt(true);
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "AFieldForceRequest",
                                    },
                                  });
                                }
                              }}
                              approveBtnText={
                                <>
                                  Approve and <br /> pay
                                </>
                              }
                              rejectBtnText={
                                <>
                                  Reject <br /> request
                                </>
                              }
                              isRejectDisable={
                                !services?.includes("AFieldForceRequest")
                              }
                              approveClick={() => {
                                if (services?.includes("AFieldForceRequest")) {
                                  const updatedAccountDetails = {
                                    request_id: schedule?.request_id,
                                    bankAccountName:
                                      schedule?.field_force_account_name,
                                    beneAccountId:
                                      schedule?.field_force_account_id,
                                    bankAccountIFSC:
                                      schedule?.field_force_account_ifsc_code,
                                    bankAccountNo:
                                      schedule?.field_force_account_bank_acc_no,
                                    categories:
                                      schedule?.category_id?.category_name,
                                    categoryId:
                                      schedule?.category_id?.category_id,
                                    requested_amount:
                                      schedule?.requested_amount,
                                    bankLogo:
                                      schedule?.field_force_account_ifsc_code,
                                    pan: "",
                                    ownerId: null,
                                    ownerAccountName: "",
                                    ownerBankIFSC: null,
                                    ownerBankBalance:
                                      GlobalConfiguration.lengthCheckZero,
                                    ownerBankLogo: null,
                                    ownerLastUpdated: null,
                                    ownerBankAccountNo: null,
                                    selectedCategory: {
                                      configuration: schedule?.additional_data,
                                    },
                                    mergeCategory:
                                      schedule?.additional_data?.data,
                                    amountWords: "",
                                    labels: schedule?.labels || [],
                                    ownerLabels: [],
                                    comment: "",
                                    // date: schedule?.reimbursement_date,
                                    date: schedule?.request_date,
                                    expenseType: schedule?.expense_type,
                                    description:
                                      currentAccountDetails?.description ?? "",
                                    uploadFile: schedule?.uploaded_file_data,
                                  };

                                  setcurrentAccountDetails(
                                    updatedAccountDetails,
                                  );

                                  navigate(
                                    "/field_force_transaction_dashboard/create_field_force_transaction",
                                    {
                                      state: {
                                        ...updatedAccountDetails,
                                        type: "PayFieldForceTxn",
                                        flow: "PayFieldForceTxn",
                                        TypeRTGS: "RequestRTGS",
                                      },
                                    },
                                  );
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "AFieldForceRequest",
                                    },
                                  });
                                }
                              }}
                              isApproveDisable={!hasModService}
                            />
                          );
                        })}
                      </div>
                    </div>
                  </>
                  <div className="sched-detail-container w-width-full overflow-x-hidden max-w-screen-Qlg bg-primary-bg  Qsmd:pr-padding-base pl-padding-base">
                    <>
                      <div className="py-padding-md flex px-padding-md Qlg:pl-padding-base">
                        <div className="flex gap-gap-sm bg-primary-card w-auto lg:ml-margin-base min-w-0 rounded-border-radius-md overflow-x-auto no-scrollbar [&>div]:shrink-0">
                          <SwitcherTabs
                            initialActiveTab={activeDetailTab}
                            tabs={[
                              ...(hasTransactionDetails
                                ? [
                                    {
                                      label: "Transaction details",
                                      key: "Transaction details",
                                      handler: toggleTransactionDetails,
                                    },
                                  ]
                                : []),
                              {
                                label: "Category specific details",
                                key: "Category specific details",
                                handler: toggleCategorySpecificDetails,
                              },
                              {
                                label: "Support details",
                                key: "Support details",
                                handler: toggleAdditionalDetails,
                              },
                            ]}
                            setTabIndex={setTabIndex}
                          />
                        </div>
                      </div>
                    </>
                    <div className="sched-detail-pane mb-margin-md">
                      {renderDetailSection()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};
export default FieldForceRequestDetail;
